<template>
  <div class="reason-select">
    <div class="reason-select-component">
      <component v-model="reasonValue.list" :is="component.is" v-bind="component"></component>
      <rich-textarea v-if="isOtherValue" v-model="reasonValue.other" :placeholder="placeholder"></rich-textarea>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash-es'
import BizTime from './BizTime.vue'

export default {
  name: "ReasonSelect",
  components: {
    BizTime
  },
  data () {
    return {
      other: "",
      reasonValue: {
        list: [],
        other: ''
      }
    }
  },
  props: {
    value: {
      type: [Array, Object, String, Number],
      required: true,
      default: () => []
    },
    component: {
      type: Object,
      default: () => {}
    },
    otherValue: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  mounted() {
  },
  watch: {
    reasonValue: {
      deep: true,
      handler(nVal) {
        this.$emit("input", nVal)
      }
    }
  },
  computed: {
    isOtherValue() {
      const { otherValue, reasonValue } = this;
      const { list } = reasonValue
      if (otherValue && list.constructor === Array) {
        if (list.includes(otherValue)) {
          return true
        }
      } else if (otherValue && list.constructor !== Object) {
        if (list === otherValue) {
          return true
        }
      }
      return false
    }
  },
  methods: {}
};
</script>
<style  lang="scss">
.ext-info {
  padding: 0 40px;
  &-link-btn {
    width: 450px;
    margin: 0 auto;
    padding: 27px 17px;
    font-size: 25px;
  }
  &-component {
    width: 450px;
    margin: 0 auto;
  }
  .rich-radio-group[data-horz="true"] {
    display: inline-flex;
    &::after {
      border: none;
    }
    .rich-radio-wrap {
      justify-content: left;
      padding: 0;
    }
    .rich-radio:after {
      border: none;
    }
  }
}
</style>
